import { ErrorContextPropsValue } from 'context/error/types';

export function getConnectionRestoredError(errorParams: ErrorContextPropsValue, recoveryDelayInSeconds: number) {
  return {
    ...errorParams,
    error: {
      ...errorParams.error,
      icon: 'hasConnection',
      titleId: 'AppErrorReaction.connectionRestoredTitle',
      titleDefault: 'Connection Restored',
      messageId: 'AppErrorReaction.connectionRestoredDescription',
      messageDefault: "We're back online!{br}You can now try to connect and resume your activities",
    },
    retryButton: {
      ...errorParams.retryButton,
      translationId: 'AppErrorReaction.resumeBtn',
      defaultMessage: 'Resume',
    },
    autoRetryTimer: recoveryDelayInSeconds,
  };
}
